import Cookies from "js-cookie"
import { authCookieName, DEV_AUTH_DOMAIN, getAuthCookieDomain } from "@/shared/config/auth-domain"

const sharedDevScope = () => {
  const hostname = typeof window === "undefined" ? "" : window.location.hostname
  return getAuthCookieDomain() === DEV_AUTH_DOMAIN &&
    (hostname === DEV_AUTH_DOMAIN || hostname.endsWith(`.${DEV_AUTH_DOMAIN}`))
    ? { domain: DEV_AUTH_DOMAIN, path: "/", secure: true }
    : undefined
}

export const setClientAuthCookie = (name: "loggedIn" | "userInfo", value: string, options: Cookies.CookieAttributes) => {
  const cookieName = authCookieName(name)
  const scope = sharedDevScope()
  // Clean the previous host-only marker before writing the shared Dev cookie.
  if (scope) Cookies.remove(cookieName)
  Cookies.set(cookieName, value, { ...options, ...scope })
}

export const removeClientAuthCookie = (name: "loggedIn" | "userInfo") => {
  const cookieName = authCookieName(name)
  Cookies.remove(cookieName)
  const scope = sharedDevScope()
  if (scope) Cookies.remove(cookieName, scope)
}
